import React, { useContext, useState } from 'react';
import { supabase } from '../../supabaseClient';
import MyNavbar from '../navbar/navbar';
import { useParams } from 'react-router-dom';
import { JobsContext } from '../../context/jobContext';
import './job_application_form.css';
import { addJobApplied, hasJobApplied } from '../../service/localstorage_service';

const JobApplicationForm = () => {
    const { jobId } = useParams();
    const { jobs } = useContext(JobsContext);

    const job = jobs.find((job) => job.id === jobId);
    const initialFormState = {
        job_posting_id: jobId,
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        address: '',
        state: '',
        city: '',
        date_of_birth: '',
        linked_in_profile: '',
        available_start_date: '',
        years_of_experience: '',
        current_job_title: '',
        current_employer: '',
        resume_url: '',
        additional_comments: '',
        willing_to_relocate: false,
    };
    const [formData, setFormData] = useState(initialFormState);

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const [resumeFile, setResumeFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type.includes('pdf') || file.type.includes('msword'))) {
            setResumeFile(file);
            setErrors((prev) => ({ ...prev, resume: '' }));
        } else {
            setErrors((prev) => ({ ...prev, resume: 'Invalid file type. Only PDF, DOC, or image allowed.' }));
        }
    };


    const validateForm = () => {
      const newErrors = {};
      if (!formData.first_name) newErrors.first_name = 'First Name is required';
      if (!formData.last_name) newErrors.last_name = 'Last Name is required';
      if (!formData.email) newErrors.email = 'Email is required';
      if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) newErrors.email = 'Email is invalid';
      if (!formData.phone_number) newErrors.phone_number = 'Phone Number is required';
      if (!/^\d{10}$/.test(formData.phone_number)) newErrors.phone_number = 'Phone Number must be of 10 digits';
      if (!formData.address) newErrors.address = 'Address is required';
      if (!formData.state) newErrors.state = 'State is required';
      if (!formData.city) newErrors.city = 'City is required';
      if (!formData.date_of_birth) newErrors.date_of_birth = 'Date of Birth is required';
      if (!formData.years_of_experience) newErrors.years_of_experience = 'Years of Experience is required';

      if (formData.years_of_experience > 0) {
          if (!formData.current_employer) newErrors.current_employer = 'Current Employer is required';
          if (!formData.current_job_title) newErrors.current_job_title = 'Current Job Title is required';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm() || !resumeFile) {
            alert('Please fix the errors in the form');
            if (!resumeFile) setErrors((prev) => ({ ...prev, resume: 'Resume file is required' }));
            return;
        }
        try {
            // Upload 📁
            const fileName = `${jobId}/${Date.now()}_${resumeFile.name}`
            const { data, error: uploadError } = await supabase
            .storage
            .from('resumes')
            .upload(fileName, resumeFile, { upsert: false })            

            if (uploadError) throw uploadError
            
            const publicResumeUrl = "https://ovjgsszavhawovemstyk.supabase.co/storage/v1/object/public/resumes/"+data.path;

            const record = {
            ...formData,
            resume_url: publicResumeUrl,
            years_of_experience: formData.years_of_experience < 0 ? '0' : formData.years_of_experience,
            date_of_birth: formData.date_of_birth || null,
            available_start_date: formData.available_start_date || null,
            applied_at: new Date().toISOString()
            }            

            const { data: inserted, error: insertError } = await supabase
            .from('job_application')
            .insert(record)

            if (insertError) throw insertError

            addJobApplied(jobId)
            alert('Application submitted!')
            setFormData({ ...initialFormState, job_posting_id: jobId })
            setResumeFile(null)
            setErrors({})

        } catch (error) {
            console.error('Error:', error)
            alert('Submission failed.')
        }
    };

    if(hasJobApplied(jobId)){
      return (
        <>
        <MyNavbar/>
        <div className='container'>

          <div className='job-applying-to-info'>
                <h4>You're applying for</h4>
                <span>{job && `${job.company}, ${job.role}`}</span>
              </div>

              <p className='job-already-applied'>
                You already applied to this Job Opening
              </p>                      

        </div>
        </>
      );
    }

    return (
        <>
            <MyNavbar />
            <div className='container'>
              <div className='job-applying-to-info'>
                <h4>You're applying for</h4>
                <span>{job && `${job.company}, ${job.role}`}</span>
              </div>
                <form onSubmit={handleSubmit}>
                    <div className={errors.first_name ? 'form-outer error-outer': 'form-outer'}>
                        {errors.first_name && <div className="error">{errors.first_name}</div>}
                        <label className='form-label'>First Name*</label>
                        <input className='my-input form-control' type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
                    </div>
                    <div className={errors.last_name ? 'form-outer error-outer': 'form-outer'}>
                        {errors.last_name && <div className="error">{errors.last_name}</div>}
                        <label className='form-label'>Last Name*</label>
                        <input className='my-input form-control' type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
                    </div>
                    <div className={errors.email ? 'form-outer error-outer': 'form-outer'}>
                        {errors.email && <div className="error">{errors.email}</div>}
                        <label className='form-label'>Email*</label>
                        <input className='my-input form-control' type="email" name="email" value={formData.email} onChange={handleChange} />
                    </div>
                    <div className={errors.phone_number ? 'form-outer error-outer': 'form-outer'}>
                        {errors.phone_number && <div className="error">{errors.phone_number}</div>}
                        <label className='form-label'>Phone Number*</label>
                        <input className='my-input form-control' type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} />
                    </div>
                    <div className={errors.address ? 'form-outer error-outer': 'form-outer'}>
                        {errors.address && <div className="error">{errors.address}</div>}
                        <label className='form-label'>Address*</label>
                        <input className='my-input form-control' type="text" name="address" value={formData.address} onChange={handleChange} />
                    </div>
                    <div className={errors.state ? 'form-outer error-outer': 'form-outer'}>
                        {errors.state && <div className="error">{errors.state}</div>}
                        <label className='form-label'>State*</label>
                        <input className='my-input form-control' type="text" name="state" value={formData.state} onChange={handleChange} />
                    </div>
                    <div className={errors.city ? 'form-outer error-outer': 'form-outer'}>
                        {errors.city && <div className="error">{errors.city}</div>}
                        <label className='form-label'>City*</label>
                        <input className='my-input form-control' type="text" name="city" value={formData.city} onChange={handleChange} />
                    </div>
                    <div className={errors.date_of_birth ? 'form-outer error-outer': 'form-outer'}>
                        {errors.date_of_birth && <div className="error">{errors.date_of_birth}</div>}
                        <label className='form-label'>Date of Birth</label>
                        <input className='my-input form-control' type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
                    </div>
                    <div className={errors.linked_in_profile ? 'form-outer error-outer': 'form-outer'}>
                        {errors.linked_in_profile && <div className="error">{errors.linked_in_profile}</div>}
                        <label className='form-label'>LinkedIn Profile</label>
                        <input className='my-input form-control' type="url" name="linked_in_profile" value={formData.linked_in_profile} onChange={handleChange} />
                    </div>
                    <div className={errors.available_start_date ? 'form-outer error-outer': 'form-outer'}>
                        {errors.available_start_date && <div className="error">{errors.available_start_date}</div>}
                        <label className='form-label'>Available Start Date</label>
                        <input className='my-input form-control' type="date" name="available_start_date" value={formData.available_start_date} onChange={handleChange} />
                    </div>
                    <div className={errors.years_of_experience ? 'form-outer error-outer': 'form-outer'}>
                        {errors.years_of_experience && <div className="error">{errors.years_of_experience}</div>}
                        <label className='form-label'>Years of Experience</label>
                        <input className='my-input form-control' type="number" name="years_of_experience" value={formData.years_of_experience} onChange={handleChange} />
                    </div>
                    <div className={errors.current_employer ? 'form-outer error-outer': 'form-outer'}>
                        {errors.current_employer && <div className="error">{errors.current_employer}</div>}
                        <label className='form-label'>Current Employer</label>
                        <input className='my-input form-control' type="text" name="current_employer" value={formData.current_employer} onChange={handleChange} />
                    </div>
                    <div className={errors.current_job_title ? 'form-outer error-outer': 'form-outer'}>
                        {errors.current_job_title && <div className="error">{errors.current_job_title}</div>}
                        <label className='form-label'>Current Job Title</label>
                        <input className='my-input form-control' type="text" name="current_job_title" value={formData.current_job_title} onChange={handleChange} />
                    </div>
                    
                    <div className={errors.resume ? 'form-outer error-outer': 'form-outer'}>
                        {errors.resume && <div className="error">{errors.resume}</div>}
                        <label className='form-label'>Select Resume</label>
                        {/* <input className='my-input form-control' type="url" name="resume_url" value={formData.resume_url} onChange={handleChange} /> */}
                        <input className='my-input form-control' type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleFileChange}/>
                    </div>
                    <div className={errors.additional_comments ? 'form-outer error-outer': 'form-outer'}>
                        {errors.additional_comments && <div className="error">{errors.additional_comments}</div>}
                        <label className='form-label'>Additional Comments</label>
                        <textarea className='my-input form-control' name="additional_comments" value={formData.additional_comments} onChange={handleChange} />
                    </div>
                    <div className="form-outer form-checkbox">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="willing_to_relocate" name="willing_to_relocate" checked={formData.willing_to_relocate} onChange={handleChange} />
                            <label className="form-check-label" htmlFor="willing_to_relocate">
                                Willing to Relocate
                            </label>
                        </div>
                    </div>
                    <div className='submit-btn-outer'>
                        <button className='btn btn-primary-dark form-submit-btn' type="submit">Submit Application</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default JobApplicationForm;
